// src/utils/deviceUtils.ts

export const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
};

export const isIOSDevice = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isAndroidDevice = () => {
    return /Android/i.test(navigator.userAgent);
};

export const getDeviceType = () => {
    if (isIOSDevice()) return 'ios';
    if (isAndroidDevice()) return 'android';
    if (isMobileDevice()) return 'mobile';
    return 'desktop';
};

export const supportsFileSystemAccess = () => {
    return 'showDirectoryPicker' in window;
};
